<template>
  <v-dialog persistent v-model="dialog" max-width="700px">
    <v-card v-if="createLLtsDialog">
      <v-card-text>
        <v-row justify="center" class="mt-10 ml-1">
          <v-col>
            Direct replace will end the existing SLLT associated with the Transit Lead Time and create a new SLLT with the replaced Transit Lead time.
          </v-col>
        </v-row>
        <v-row class="mt-4 ml-1">
          <v-col>
          The new SLLT will also be replaced and published {{ dueDate ? `on ${dueDate} automatically` : "with today's date" }}.
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <v-row class="mt-4 ml-1">
          <v-col>
        Do you want to continue?
            </v-col>
        </v-row>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <base-input-primary-button @click="$emit('replaceTltAndSllt')" label="Yes"/>
        <base-input-secondary-button @click="$emit('closeSaveAndCreateLLtsDialog')" label="No"/>
      </v-card-actions>
    </v-card>

    <v-card v-if="createLLtsResultDialog">
      <v-card-text>
        <v-row justify="center" class="pt-16 mb-5">
          The new transit lead times have been created and the previous ones have ended, along with its SLLTs.
          New logistic SLLTs have been created.
        </v-row>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <base-input-primary-button @click="goToLogisticLTs()" label="Go to SLLT search"/>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import BaseInputPrimaryButton from '@/base/input/BaseInputPrimaryButton'
import BaseInputSecondaryButton from '@/base/input/BaseInputSecondaryButton'

export default {
  name: 'ReplaceTransitLeadTimeDialog',
  components: {
    BaseInputSecondaryButton,
    BaseInputPrimaryButton
  },
  props: {
    dialog: {
      type: Boolean,
      require: true
    },
    createLLtsDialog: {
      type: Boolean,
      require: true
    },
    createLLtsResultDialog: {
      type: Boolean,
      require: true
    },
    dueDate: {
      type: String,
      required: false
    }
  },
  methods: {
    goToLogisticLTs () {
      this.$router.push({ name: 'SearchLogisticsLeadTime' })
    }
  }
}
</script>

<style scoped>

</style>
